<script>
import { postPaged } from '@/services/paginated';
import axios from 'axios';
let user = JSON.parse(localStorage.getItem('user'));

export default {
  data() {
    return {
      columns: [
       { label: "Tên người dùng", field: "username" },
        { label: "Email đăng nhập", field: "email" },
        { label: "Vai trò", field: "admin" }, // 🆕 thêm cột vai trò
        { label: "Trạng thái", field: "band" },
        { label: "Hành động", field: "_id", width: "140px" }
      ],
      rows: [],
      totalRows: 0,
      page: 1,
      perPage: 10,
      searchTerm: '',
      isLoading: false,
    };
  },

  async created() {
    // Khởi tạo lần đầu
    if (user) {
      await this.fetchRows();
    }
  },

  methods: {
    /** Gọi API lấy danh sách user có phân trang */
    async fetchRows() {
      this.isLoading = true;
      try {
        const { items, total } = await postPaged('/api/user/list', {
          page: this.page,
          limit: this.perPage,
          search: this.searchTerm,
        });
        this.rows = items;
        this.totalRows = total;
      } catch (err) {
        console.error('Lỗi tải danh sách tài khoản:', err);
        this.rows = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },

    /** Chuyển trang */
    onPageChange({ currentPage }) {
      this.page = currentPage;
      this.fetchRows();
    },

    /** Đổi số dòng/trang */
    onPerPageChange({ currentPerPage }) {
      this.perPage = currentPerPage;
      this.page = 1;
      this.fetchRows();
    },

    /** Tìm kiếm (nếu cần backend hỗ trợ search) */
    onSearch({ searchTerm }) {
      this.searchTerm = searchTerm;
      this.page = 1;
      this.fetchRows();
    },

    /** Ban tài khoản */
    del(_id) {
      axios({
        url: process.env.VUE_APP_SERVER_URL + '/api/user/update',
        method: 'post',
        headers: {
          authorization: user.token,
        },
        data: {
          _id: _id,
          band: true,
        },
      }).then(() => {
        this.$toasted.success('Band tài khoản thành công');
        this.fetchRows();
      });
    },

    /** Sửa tài khoản */
    edit(_id) {
      this.$router.push({
        name: 'edit-user-info',
        query: {
          id: _id,
        },
      });
    },
  },
};
</script>

<template>
  <div class="mb-5">
    <div>
      <h3 class="h5">Danh sách tài khoản</h3>
      <hr />
    </div>

    <vue-good-table
      :columns="columns"
      :rows="rows"
      :total-rows="totalRows"
      :pagination-options="{
        enabled: true,
        rowsPerPageLabel: 'các mục trong trang',
        nextLabel: 'tiếp',
        prevLabel: 'trước',
        mode: 'records',
        perPage: perPage,
        perPageDropdown: [10, 20, 50],
        allLabel: 'Tất cả',
      }"
      :line-numbers="true"
      :search-options="{ enabled: true }"
      mode="remote"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
      @on-search="onSearch"
    >
      <template slot="table-row" slot-scope="props">

          <!-- Vai trò -->
        <span v-if="props.column.field == 'admin'">
          {{ props.row.admin ? 'Admin' : 'Thành viên' }}
        </span>
        <!-- Trạng thái -->
         
        <span v-if="props.column.field == 'band'">
            {{ props.row.band  ? 'Bị khóa' : 'Hoạt động' }}
        </span>

        <!-- Cột hành động -->
         
        <span v-else-if="props.column.field === '_id'">
          <button
            type="button"
            @click="edit(props.formattedRow[props.column.field])"
            class="btn btn-primary btn-sm mx-2"
          >
            Sửa
          </button>
          <!-- Giữ logic band, ẩn mặc định -->
          
          <button
            type="button"
            @click="del(props.formattedRow[props.column.field])"
            class="btn btn-danger btn-sm"
          >
            Ban
          </button>
        </span>

        <!-- Các cột khác -->
        <span v-if="['username', 'email'].includes(props.column.field)">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<style scoped>
.vgt-table td,
.vgt-table th {
  white-space: nowrap;
  vertical-align: middle;
}
</style>
